/** Direct media needs a native player, not a YouTube iframe. */
export function isNativeVideo(url: string): boolean {
  try { return /\.(mp4|webm|ogg|ogv|m4v)$/i.test(new URL(url, url.startsWith('/') && !url.startsWith('//') ? 'https://screen.invalid' : undefined).pathname); }
  catch { return false; }
}

/** Normalise any YouTube URL shape into a no-cookie autoplay embed. */
export function toEmbed(url: string, muted: boolean): string {
  try {
    const u = new URL(url);
    let id: string | null = null;
    if (u.hostname === "youtu.be") id = u.pathname.slice(1);
    else if (["youtube.com", "www.youtube.com", "m.youtube.com", "youtube-nocookie.com", "www.youtube-nocookie.com"].includes(u.hostname) && u.searchParams.get("v")) id = u.searchParams.get("v");
    else if (["youtube.com", "www.youtube.com", "m.youtube.com", "youtube-nocookie.com", "www.youtube-nocookie.com"].includes(u.hostname)) {
      const m = u.pathname.match(/\/(embed|shorts)\/([\w-]{11})/);
      if (m) id = m[2];
    }
    if (!id || !/^[\w-]{11}$/.test(id)) return url;
    const start = parseInt(u.searchParams.get("t") ?? "", 10);
    let src =
      `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0` +
      `&enablejsapi=1&playsinline=1&loop=1&playlist=${id}${muted ? "&mute=1" : ""}`;
    if (Number.isFinite(start) && start > 0) src += `&start=${start}`;
    return src;
  } catch {
    return url;
  }
}
